import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "load-messages";

  connect() {
    super.connect();
    this.send("connect", {}, () => {
      this.bridgeElement.click();
    });
  }
}
